import React from 'react';
import { Modal, Button, Text, Link, List, ListItem } from '@heartinternet/hi-ui';

export interface UpgradeMailboxModalProps {
  isOpen: boolean;
  /** null/number/string as provided by the backend; '-1' → bulk purchase (can't upgrade). */
  upgradePrice: string | number;
  submitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Upgrade an Essential mailbox to Pro. Two states, mirroring list.tt + manage.js:
 * - bulk purchase (price '-1'): explains the mailbox can't be upgraded automatically.
 * - otherwise: confirms the upgrade price.
 */
export const UpgradeMailboxModal: React.FC<UpgradeMailboxModalProps> = ({
  isOpen,
  upgradePrice,
  submitting = false,
  onClose,
  onConfirm,
}) => {
  const isBulk = String(upgradePrice) === '-1';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Upgrade mailbox"
      size="medium"
      footer={
        <div className="hi-ui-be-modal-actions">
          {isBulk ? (
            <Button variant="primary" onClick={onClose}>
              Ok
            </Button>
          ) : (
            <>
              <Button variant="tertiary" onClick={onClose} disabled={submitting}>
                No
              </Button>
              <Button
                variant="primary"
                onClick={onConfirm}
                loading={submitting}
                disabled={submitting}
              >
                Yes
              </Button>
            </>
          )}
        </div>
      }
    >
      {isBulk ? (
        <>
          <Text variant="body">In order to upgrade this mailbox you must:</Text>
          <List listStyle="disc">
            <ListItem>
              Purchase a single Business Email Pro mailbox{' '}
              <Link href="/manage/extras.cgi?chosen=mailbox">here</Link>
            </ListItem>
            <ListItem>Contact support to migrate your mailbox to the new Pro mailbox</ListItem>
          </List>
        </>
      ) : (
        <Text variant="body">{`Do you want to upgrade this mailbox for £${String(upgradePrice)}?`}</Text>
      )}
    </Modal>
  );
};
